import React, { useMemo } from 'react';
import { FdsIcon } from '@tcc/fds';
import { getMessage } from '@tcc/i18n';
import { getSupportUrl } from '../utils/support';

interface NavFooterParams {
  expanded: boolean;
  setExpandedState: (isExpanded: boolean) => void;
  countryCode?: string;
  featureFlags?: Record<string, boolean>;
}

interface FooterItem {
  label: string;
  href?: string;
  icon?: React.ReactElement;
  testId?: string;
  target?: string;
  onClick?: () => void;
}

export const useNavFooterItems = ({
  expanded,
  setExpandedState,
  countryCode,
  featureFlags = {},
}: NavFooterParams): FooterItem[] => {
  const support = useMemo(() => ({
    leadingIcon: FdsIcon.Help,
    href: getSupportUrl(countryCode),
    testId: 'information-architecture-support',
    target: '_blank',
    label: getMessage('sidenav.support')
  }), [countryCode]);

  const expandCollapseButton = useMemo(() => ({
    leadingIcon: expanded ? FdsIcon.ArrowMenuClose : FdsIcon.ArrowMenuOpen,
    testId: expanded ? 'information-architecture-collapse-button' : 'information-architecture-expand-button',
    onClick: () => setExpandedState(!expanded),
    label: expanded ? getMessage('sidenav.collapseMenu') : getMessage('sidenav.openMenu')
  }), [expanded, setExpandedState]);

  const askFieldView = useMemo(() => {
    if (!featureFlags['web.ask-fieldview-web']) {
      return null;
    }
    return {
      leadingIcon: FdsIcon.Help,
      href: 'https://climate.com/static/field-view/#/ask-fieldview-web/',
      testId: 'farmer-nav-askfieldview-bottom',
      label: getMessage('sidenav.ask')
    };
  }, [featureFlags]);

  return [
    support,
    ...(askFieldView ? [askFieldView] : []),
    expandCollapseButton,
  ];
};
